import { BodyLarge, Button, Heading2 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'
import { handleClick, handleShow } from '@/utils/tracking/eventsHandlers'

import { ConceptImage } from '../ConceptImage'

import { noResults } from './styles.css'

type Props = {
  buttonTitle: string
  description: string
  eventTracking: [GTMEventCategory, string, string?]
  onClick: VoidFunction
  title: string
}

export const NoResults: React.FC<Props> = ({ buttonTitle, description, eventTracking, onClick, title }) => {
  const { t } = useTranslation()
  const [eventCategory, eventLabel, eventValue] = eventTracking

  const buttonClick = () => {
    handleClick(eventCategory, eventLabel, eventValue)
    onClick()
  }

  useEffect(() => {
    handleShow(GTMEventCategory.SuggestedPage, 'NoResults')
  }, [])

  return (
    <div className={noResults}>
      <div className={sprinkles({ marginBottom: 'xl', textAlign: 'center' })}>
        <ConceptImage height={130} name="empty-street" width={130} />
      </div>
      <Heading2 alignment="center" className={sprinkles({ paddingBottom: 'm' })}>
        {t(title)}
      </Heading2>
      <BodyLarge alignment="center" className={sprinkles({ paddingBottom: 'xl' })} color="greyscale500">
        {t(description)}
      </BodyLarge>
      <Button label={t(buttonTitle)} onClick={buttonClick} />
    </div>
  )
}
